import React, { useEffect } from "react";
import PropTypes from "prop-types";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import useGetCampaignCountdown from "hooks/useGetCampaignCountdown";

const DaysRemaining = ({ date }) => {
  const { translate: t } = useLanguageProvider();
  const {
    dateCount, dateUnit, setEndTime, hasEnded,
  } = useGetCampaignCountdown();

  useEffect(() => {
    setEndTime(date);
  }, [date, setEndTime]);

  if (hasEnded) {
    return null;
  }

  return (
    <div className="campaign-container__share-values" data-test="campaign-days-left">
      <h3>{dateCount}</h3>
      <p data-test="duration-type" className="campaign-container__share-values-subtitle --small">
        {t(":unit left", { unit: t(dateUnit) })}
      </p>
    </div>
  );
};

DaysRemaining.propTypes = {
  date: PropTypes.any.isRequired,
};

export default DaysRemaining;
